import {
    SET_TRACKIER_PUBLISHER_MANAGEMENT,
    CLEAR_TRACKIER_PUBLISHER_MANAGEMENT,
    GET_TRACKIER_PUBLISHER_MANAGEMENT_SUCCESS,
    GET_TRACKIER_PUBLISHER_MANAGEMENT_FAILED,
} from '../../actions/type';

const initialState = { data: null, status: 'idle' };

export default function trackierPublisherManagementReducer(state = initialState, action) {
    const { type, data } = action;

    switch (type) {
        case SET_TRACKIER_PUBLISHER_MANAGEMENT:
            return {
                ...state,
                data,
            }
        case CLEAR_TRACKIER_PUBLISHER_MANAGEMENT:
            return {
                ...state,
                data: null,
            }
        case GET_TRACKIER_PUBLISHER_MANAGEMENT_SUCCESS:
            return {
                ...state,
                status: 'success',
            }
        case GET_TRACKIER_PUBLISHER_MANAGEMENT_FAILED:
            return {
                ...state,
                error: data,
                status: 'failed',
            }

        default:
            return state;
    }
}